import {Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef} from '@angular/core';
import { Router } from '@angular/router';
import { PosIntegrationService } from '../../../../../../services/pos-integration.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-shopify-defaults',
  templateUrl: './shopify-defaults.component.html',
  styleUrls: ['./shopify-defaults.component.scss'],
  providers: [MessageService],
})
export class ShopifyDefaultsComponent implements OnInit {
  @Input() partner;
  @Output() status = new EventEmitter();
  public partnerID;
  public busy = true;
  public config: any = {};
  public registers: any = [];
  public taxes: any = [];
  public users: any = [];
  public locations: any = [];
  public paymentTypes: any = [];
  public isWizard: boolean = false;
  public isModalOpen = false;

  public category: string = '';
  public taxRate: number = 0;

  constructor(
    private posIntegrationService: PosIntegrationService,
    private messageService: MessageService,
    private translate: TranslateService,
    private router: Router,
  ) {
    if (this.router.url.indexOf('bikeshop-wizard') > -1) {
      this.isWizard = true;
    }
  }

  taxesUsed: any = [
    //{ "taxRate": "8", "category": "dsad231ff" },
    //{ "taxRate": "7.2", "category": "gwregre345" }
  ];
  categories: any = [
    //{ "id": "", label: '', value: '' },
    //{ "id": "Audi", label: 'Audi', value: 'Audi' },
    //{ "id": "BMW", label: 'BMW', value: 'BMW' },
    //{ "id": "Fiat", label: 'Fiat', value: 'Fiat' },
    //{ "id": "Ford", label: 'Ford', value: 'Ford' },
    //{ "id": "Honda", label: 'Honda', value: 'Honda' },
    //{ "id": "Jaguar", label: 'Jaguar', value: 'Jaguar' },
    //{ "id": "Mercedes", label: 'Mercedes', value: 'Mercedes' },
    //{ "id": "Renault", label: 'Renault', value: 'Renault' },
    //{ "id": "VW", label: 'VW', value: 'VW' },
    //{ "id": "Volvo", label: 'Volvo', value: 'Volvo' }
  ];

  ngOnInit() {
    this.partnerID = this.partner.ID || this.partner.PartnerID;
    this.getLocations();
    this.getConfig();
    this.getTaxes();
  }

  getTaxes() {
    console.log('getting taxes');
    this.posIntegrationService
      .getShopifyStoreDetails(this.partnerID)
      .subscribe((res) => {
        console.log(res);
        console.log(res.Taxes);
        console.log(res.UsedTaxes);
        this.categories = [];
        this.taxesUsed = [];
        res.UsedTaxes.forEach((x) => {
          this.categories.push({ id: x, label: x, value: x });
        });
        res.Taxes.forEach((x) => {
          this.categories = this.categories.filter(function (el) {
            return el.id != x.Category;
          });
          this.taxesUsed.push({ taxRate: x.Rate, category: x.Category });
        });
      });
  }

  getConfig() {
    this.posIntegrationService.getShopifyConfig(this.partnerID).subscribe(
      (res) => {
        this.config = res;
        console.log(this.config);
        this.busy = false;
      },
      (err) => {
        this.busy = false;
      },
    );
  }

  getLocations() {
    this.posIntegrationService
      .getShopifyLocations(this.partnerID)
      .subscribe((res) => {
        this.locations = res.map((x) => {
          return { label: x.Description, value: x.ID.toString() };
        });
      });
  }

  updateConfig() {
    this.busy = true;
    this.config.ID = this.partnerID;
    this.posIntegrationService.updateShopifyConfig(this.config).subscribe(
      (result) => {
        this.busy = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant('onboarding.pos_settings_updated'),
        });
        this.status.emit({ configurationSaved: true });
      },
      (err) => {
        this.busy = false;
      },
    );
  }

  addCustomTaxRate() {
    this.posIntegrationService
      .updateShopifyStoreDetails(this.partnerID, {
        PartnerID: this.partnerID,
        LocationID: '',
        Category: this.category,
        TaxRate: this.taxRate,
      })
      .subscribe((x) => {
        var c = this.category;
        this.taxesUsed.push({ taxRate: this.taxRate, category: this.category });
        this.categories = this.categories.filter(function (el) {
          return el.id != c;
        });
        this.taxRate = 0;
        this.category = '';
      });
  }

  removeCustomTaxRate(category) {
    //this.taxesUsed = this.taxes.filter(function (el) { return el.category != category; });
    this.posIntegrationService
      .deleteShopifyStoreDetails(this.partnerID, {
        PartnerID: this.partnerID,
        LocationID: '',
        Category: category,
        TaxRate: 0,
      })
      .subscribe((x) => {
        this.getTaxes();
      });
  }

  syncProducts() {
    this.posIntegrationService.syncPOSNew(this.partnerID).subscribe((x) => {
      this.messageService.add({
        life: 5000,
        detail: this.translate.instant(
          'bikeshop.quicklaunch.pos_products_sync',
        ),
      });
    });
  }

  openModal(event) {
    event.preventDefault();  // Prevents the dropdown from opening
    event.stopPropagation(); // P
    this.isModalOpen = true;
    console.log(this.categories)
  }

  closeModal() {
    this.isModalOpen = false;
  }

  catergoryHeight = '15rem'

  checkValidCategories(){
    if (!this.categories){
      return false;
    }
    if (this.categories.length === 1 && this.categories[0].id === '' && this.categories[0].label == "" && this.categories[0].value == ""){
      return false;
    }

    return true;

  }

}
